<template>
  <div>
    <p>{{ warehouse.name }}</p>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th colspan="2">Kategorie</th>
          <th class="text-center">Artikel auf Lager</th>
          <th class="text-center">EK Gesamt</th>
          <th class="text-center">VK Gesamt</th>
        </tr>
      </thead>
      <tbody is="ProductCategoryValue" class="table-striped"
        v-for="productCategory in productCategoriesToDisplay" :key="productCategory.id"
        :product-category="productCategory" :warehouse="warehouse"
        @openProducts="$emit('openProducts', $event)"
      />
      <tfoot>
        <tr>
          <td colspan="2"><strong>Summe:</strong></td>
          <td class="text-right"><strong>{{ quantitySum }}</strong></td>
          <td  class="text-right"><strong>{{ ekSum | priceFromCentEuro }}</strong></td>
          <td  class="text-right"><strong>{{ vkSum | priceFromCentEuro }}</strong></td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import ProductCategoryValue from './product-category-value'

export default {
  props: ['warehouse', 'productCategories'],
  components: { ProductCategoryValue },
  computed: {
    productCategoriesToDisplay () {
      return this.productCategories.filter(category => {
        if (!this.warehouse.productCategories[category.id]) {
          return category.child_categories.some(childCategory => this.warehouse.productCategories[childCategory.id])
        }
        return true
      })
    },
    quantitySum () {
      return Object.values(this.warehouse.productCategories).reduce((sum, { bla_quantity: quantity }) => sum + +quantity, 0)
    },
    ekSum () {
      return Object.values(this.warehouse.productCategories).reduce((sum, { summe_ek: summeEk }) => sum + +summeEk, 0)
    },
    vkSum () {
      return Object.values(this.warehouse.productCategories).reduce((sum, { summe_vk: summeVk }) => sum + +summeVk, 0)
    }
  }
}
</script>
